import { render } from "./DSelect.vue?vue&type=template&id=db23ee2c&ts=true"
import script from "./DSelect.vue?vue&type=script&lang=ts"
export * from "./DSelect.vue?vue&type=script&lang=ts"

import exportComponent from "d:\\jenkins-nodes\\Atlanta\\workspace\\Atlanta-FE-Git-189PRE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__